import { getActivistShortsFillingsData } from '../config/server-config';
import { API_CALL_SUCCESSFULL } from '../constants/NumberConstants';
import { ACTIVIST_SHORTS } from '../constants/ProductConstants';
import api from '../api';

export const GetActivistShortsFillingsData = async ({ cancelToken }) => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.post(
      getActivistShortsFillingsData,
      { product_id: ACTIVIST_SHORTS, token },
      {
        cancelToken: cancelToken,
      },
    );
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export default { GetActivistShortsFillingsData };
